import { render, staticRenderFns } from "./FooterSmall.vue?vue&type=template&id=7d6ced8f&scoped=true&"
import script from "./FooterSmall.vue?vue&type=script&lang=js&"
export * from "./FooterSmall.vue?vue&type=script&lang=js&"
import style0 from "./FooterSmall.vue?vue&type=style&index=0&id=7d6ced8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ced8f",
  null
  
)

export default component.exports